// Server timeout 30sec
export const apiTimeout = 30000;

export const defaultPageSize = 20;
